import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getBookings = async (userId) => {

    const { data, error } = await supabase
        .from('booking_transactions')
        .select(`
            *,
            team:team_id (*)
        `)
        .eq('user_id', userId)
        .in('status', ['Completed', 'Booked', 'Paid']);

    if (error) {
        throw new Error(`Error fetching bookings: ${error.message}`);
    }

    return data;
};


export default function useGetMyBookings(userId) {
    return useQuery({
        queryKey: ['useGetMyBookings', userId],
        queryFn: () => getBookings(userId),
        staleTime: 0,
        enabled: !!userId
    })
}
